import { render, staticRenderFns } from "./UserDiscover.vue?vue&type=template&id=4843ddce&scoped=true&"
import script from "./UserDiscover.vue.ts?vue&type=script&lang=ts&"
export * from "./UserDiscover.vue.ts?vue&type=script&lang=ts&"
import style0 from "./UserDiscover.vue.scss?vue&type=style&index=0&id=4843ddce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843ddce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VImg,VProgressLinear,VTextField})
